export enum PopupName {
	AutomaticLogout,
	RealityCheck,
	User24LockActive,
	AccountVerification,
	WelcomePopup,
	FailedLogins,
	SessionExpire,
	CashoutExpire,
	OnboardingNewsletter,
	OnboardingRegister,
	RequiredUserActions,
	QuickPlay,
	CookieConsent,
	BetBuilder,
	UseBonus,
	PromoModal,
	ChatBetSlipShare,
	FavoritePopup,
	ShowPromo,
	SharedBetSlip,
	BettingTips,
}
